import React from 'react';

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 11V8a4 4 0 1 1 8 0v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const COURSE_VARIANT_BY_ID = {
  'digital-strengths': 'spark',
  'digital-purpose-values': 'compass',
  'digital-self-presentation': 'stage',
  'digital-gratitude': 'sun',
};

export function CourseIcon({ variant }) {
  switch (variant) {
    case 'spark':
      return (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M24 6l2.8 9.2L36 18l-9.2 2.8L24 30l-2.8-9.2L12 18l9.2-2.8L24 6z"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinejoin="round"
          />
          <path d="M34 32l1.4 4.6 4.6 1.4-4.6 1.4L34 44l-1.4-4.6-4.6-1.4 4.6-1.4L34 32z" fill="currentColor" opacity="0.85" />
        </svg>
      );
    case 'compass':
      return (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="24" cy="24" r="16" stroke="currentColor" strokeWidth="2.2" />
          <path d="M24 14l4 10 10 4-10 4-4 10-4-10-10-4 10-4 4-10z" fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <circle cx="24" cy="24" r="2.5" fill="currentColor" />
        </svg>
      );
    case 'stage':
      return (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8 36h32" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M14 36V22l10-8 10 8v14" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
          <circle cx="24" cy="16" r="4" stroke="currentColor" strokeWidth="2" />
          <path d="M20 28h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'sun':
      return (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth="2.2" />
          <path d="M24 6v4M24 38v4M6 24h4M38 24h4M11 11l3 3M34 34l3 3M37 11l-3 3M14 34l-3 3" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="10" y="6" width="28" height="36" rx="6" stroke="currentColor" strokeWidth="2.2" />
          <path d="M18 38h12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
          <path d="M20 12h8M20 17h12M20 22h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
  }
}

export default function CourseOfferCard({ course, index = 0, onOpen, locked = false }) {
  const variant = COURSE_VARIANT_BY_ID[course.id] || 'default';
  const num = String(index + 1).padStart(2, '0');

  return (
    <article
      className={`gl-offer-card gl-offer-card--${variant}${locked ? ' gl-offer-card--locked' : ''}`}
      style={{ '--card-enter-delay': `${index * 90}ms` }}
      aria-disabled={locked ? 'true' : undefined}
    >
      <div className="gl-offer-card-accent" aria-hidden="true" />
      <div className="gl-offer-card-shine" aria-hidden="true" />
      <div className="gl-offer-card-head">
        <span className="gl-offer-card-num">{num}</span>
        <div className="gl-offer-card-head-end">
          {locked ? (
            <p className="gl-course-tile-soon">
              <LockIcon />
              <span>בקרוב</span>
            </p>
          ) : null}
          <span className="gl-offer-card-icon">
            <CourseIcon variant={variant} />
          </span>
        </div>
      </div>

      {course.price && (
        <p className="gl-offer-card-price" aria-label={`מחיר: ${course.price}`}>
          <span className="gl-offer-card-price-chip">
            <span className="gl-offer-card-price-label">מחיר</span>
            <span className="gl-offer-card-price-value">{course.price}</span>
          </span>
        </p>
      )}

      <h3>{course.title}</h3>
      <p className="gl-offer-card-text">{course.summary}</p>

      {course.includes?.length > 0 && (
        <div className="gl-offer-card-includes">
          <p className="gl-offer-card-includes-title">מה יהיה שם</p>
          <ul>
            {course.includes.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {locked ? (
        <div className="gl-offer-card-cta gl-offer-card-cta--disabled" aria-hidden="true">
          <span className="gl-offer-card-cta-label">היכנס לקורס</span>
          <span className="gl-offer-card-cta-arrow" aria-hidden="true">←</span>
        </div>
      ) : (
        <button
          type="button"
          className="gl-offer-card-cta"
          onClick={() => onOpen(course)}
        >
          <span className="gl-offer-card-cta-label">היכנס לקורס</span>
          <span className="gl-offer-card-cta-arrow" aria-hidden="true">←</span>
        </button>
      )}
    </article>
  );
}

export function LockedCourseCard(props) {
  return <CourseOfferCard {...props} locked />;
}
